import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { RolesWeb } from 'src/app/core/enums/roles.enum';
import { BranchOfficeModel } from 'src/app/core/models/branch-office.model';
import { SessionCacheModel } from 'src/app/core/models/session-cache.model';
import { User } from 'src/app/core/models/user';
import { UserResponsibleModel } from 'src/app/core/models/user-responsible.model';
import { IdentityService } from 'src/app/core/services/identity.service';
import { SessionCacheService } from 'src/app/core/services/session-cache.service';
import { UserService } from 'src/app/core/services/user.services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-branches',
  templateUrl: './branches.component.html',
  styleUrls: ['./branches.component.scss']
})
export class BranchesComponent implements OnInit {
  private readonly SUCURSALES: string = 'branchs';
  private readonly TO_MILISECONDS: number = environment.throttledRefreshBalance * 6000;

  loading: boolean = false;
  branches: BranchOfficeModel[];
  filterBranches: BranchOfficeModel[];
  loggedUser: User;
  search = new UntypedFormControl('');
  currentPage: number = 1;
  showSucursalInfo: boolean = false;
  selectedBranch: BranchOfficeModel = null;
  userModel: UserResponsibleModel;

  constructor(
    private router: Router,
    private sessionCacheService: SessionCacheService,
    private userService: UserService,
    private identity: IdentityService
  ) {
    this.userModel = new UserResponsibleModel();
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.loggedUser = this.identity.getUser();

    await this.loadBranchOffices();

    this.search.valueChanges.pipe(debounceTime(150)).subscribe((value) => {
      if (value) {
        this.currentPage = 1;
        this.filterBranches = this.branches.filter((branch) => branch.name.toUpperCase().includes(value.toUpperCase()));
      } else {
        this.currentPage = 1;
        this.filterBranches = this.branches;
      }
    });
    this.loading = false;
  }

  async loadBranchOffices(): Promise<BranchOfficeModel[]> {
    this.sessionCacheService.expiredData(this.SUCURSALES);
    !this.sessionCacheService.getData(this.SUCURSALES) ? await this.saveBranchsInCache() : this.getBranchesInCache();
    return this.branches;
  }

  async saveBranchsInCache(): Promise<void> {
    let cache = new SessionCacheModel();
    this.branches = await this.userService.getBranchOfficesCollection();
    this.filterBranches = this.branches;
    cache.data = this.branches;
    cache.iat = +new Date() + this.TO_MILISECONDS;
    this.sessionCacheService.saveDataWithExpiration(this.SUCURSALES, cache);
  }

  getBranchesInCache(): void {
    this.branches = JSON.parse(this.sessionCacheService.getData(this.SUCURSALES)).data;
    this.filterBranches = this.branches;
  }

  goToAgregarSucursal(isEdition: boolean = false, id: number): void {
    isEdition
      ? this.router.navigate(['/user/my-commerce/branches/edit'], { queryParams: { branch: id } })
      : this.router.navigate(['/user/my-commerce/branches/create']);
  }

  goToEditSucursal(data: BranchOfficeModel): void {
    this.goToAgregarSucursal(true, data.id);
  }

  get loggedUserIsResponsible(): boolean {
    return this.identity.hasRolId(RolesWeb.RESPONSABLE);
  }
}
